import { all, put, takeEvery } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { executeSagaRequest } from '@savgroup-front-common/core/services';

import { getSellersRequest } from '../../api/Seller/sellers/getSellersQuery';

import { LOAD_SELLERS_INFO } from './actionTypes';

function* loadSellersWorker(): Generator {
  yield executeSagaRequest(LOAD_SELLERS_INFO, getSellersRequest());

  yield put(LOAD_SELLERS_INFO.end());
}

function* loadSellersWatcher() {
  yield takeEvery(LOAD_SELLERS_INFO.BASE, loadSellersWorker);
}

export default function* mainSaga(): Generator {
  try {
    yield all([loadSellersWatcher()]);
  } catch (error) {
    logCritical(error);
  }
}
